import { ErrorCode, FlexSdkError } from "~/modules/error";

export const defaultRetryConditionOnFlexSdkError = (flexSdkError: FlexSdkError): boolean => {
    const retryOnErrors = [ErrorCode.Unknown, ErrorCode.TooManyRequests, ErrorCode.NetworkError];

    return retryOnErrors.includes(flexSdkError.code);
};
